import { render, staticRenderFns } from "./IconTrendingUpOutline.vue?vue&type=template&id=6508ceb5"
import script from "./IconTrendingUpOutline.vue?vue&type=script&lang=js"
export * from "./IconTrendingUpOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports